import { Injectable } from '@angular/core';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { GlobalService } from './global.service';
import { Observable } from 'rxjs';
import { catchError, retry } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class AssocService {

  constructor(
    private http: HttpClient,
    private globalService: GlobalService
  ) { }

  getCustomer(token){
    let httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': token
      })
    };
    return this.http.get<any>(this.globalService.getCustomer, httpOptions)
  }

  assocContractToCustomers(token, customers, contractId): Observable<any>{
    let httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': token
      })
    };
    return this.http.post<any>(this.globalService.getGetAssocContractToCustomerURL(contractId), customers, httpOptions).pipe(
      retry(1),
      catchError(this.globalService.handleError)
    )
  }

  getAssocCustomersToContract(token, contractId): Observable<any>{
    let httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': token
      })
    };
    return this.http.get<any>(this.globalService.getGetAssocedCustomerToContractURL(contractId), httpOptions).pipe(
      retry(1),
      catchError(this.globalService.handleError)
    )
  }

  
}
